import { Check, Gift } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/site/Reveal";
import { CtaButton } from "@/components/site/CtaButton";

const PACKS = [
  { id: "pack-1", tag: "Sample package", jars: 1, supply: "30-day supply", per: 79, total: null, bonus: false },
  { id: "pack-6", tag: "Most popular", jars: 6, supply: "180-day supply", per: 39, total: 234, bonus: true, hot: true },
  { id: "pack-3", tag: "Great deal", jars: 3, supply: "90-day supply", per: 59, total: 177, bonus: true },
];
const BONUSES = [["Prostate Health Smoothies", "A recipe guide using easy-to-find grocery ingredients. Listed at $37 value."], ["Healthy Sex Drive Plan", "Tips and daily habits to support desire and endurance."]];

const Pack = ({ p, i }) => (
  <Reveal delay={i * 0.1} className="h-full">
    <div data-testid={`prosta-${p.id}-card`}
      className={`relative flex h-full flex-col rounded-[2rem] p-7 transition-transform duration-500 hover:-translate-y-1 ${p.hot ? "bg-[#071E33] text-[#F2EDE4] lg:-my-6 lg:py-12" : "bg-white text-[#071E33]"}`}>
      <span className={`self-start rounded-full px-3 py-1 font-mono text-[11px] uppercase tracking-[0.2em] ${p.hot ? "bg-[#00AEEF] text-[#071E33]" : "bg-[#071E33]/5 text-[#0A6FA0]"}`}>{p.tag}</span>
      <p className="mt-6 font-display text-3xl font-bold">{p.jars} {p.jars === 1 ? "Bottle" : "Bottles"}</p>
      <p className={`text-sm ${p.hot ? "text-[#F2EDE4]/70" : "text-[#071E33]/65"}`}>{p.supply}</p>
      <p className="mt-6 flex items-baseline gap-1">
        <span className="font-display text-6xl font-extrabold tracking-tight" data-testid={`prosta-${p.id}-price`}>${p.per}</span>
        <span className={`text-sm ${p.hot ? "text-[#F2EDE4]/70" : "text-[#071E33]/65"}`}>/ bottle</span>
      </p>
      <p className={`mt-1 text-sm ${p.hot ? "text-[#F2EDE4]/70" : "text-[#071E33]/65"}`}>{p.total ? `$${p.total} total` : "Single bottle"}</p>
      <ul className="mt-6 space-y-2 text-sm">
        <li className="flex items-center gap-2"><Check className="h-4 w-4 text-[#00AEEF]" /> One scoop a day</li>
        {p.bonus && <li className="flex items-center gap-2"><Gift className="h-4 w-4 text-[#00AEEF]" /> 2 free bonus guides</li>}
      </ul>
      <div className="mt-auto pt-8">
        <CtaButton testId={`prosta-${p.id}-button`} placement={p.id} product="prostavive" variant="sky" className={`w-full justify-between ${p.hot ? "" : "hover:!bg-[#071E33] hover:!text-[#F2EDE4]"}`}>
          Choose {p.jars} {p.jars === 1 ? "bottle" : "bottles"}
        </CtaButton>
      </div>
    </div>
  </Reveal>
);

export const ProstaPricing = () => (
  <section id="offer" className="relative bg-[#F2EDE4] py-24 sm:py-32" data-testid="prosta-pricing-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow className="!text-[#0A6FA0]">Powerhouse Prostate Offer</Eyebrow>
        <h2 className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tight text-[#071E33] sm:text-5xl">
          Pick your <span className="font-serif italic font-normal text-[#0A6FA0]">supply.</span>
        </h2>
        <p className="mt-5 text-base text-[#071E33]/75">Prices as listed on the official ProstaVive site. Always confirm the final price at checkout.</p>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 items-stretch gap-5 lg:grid-cols-3 lg:py-6">
        {PACKS.map((p, i) => <Pack key={p.id} p={p} i={i} />)}
      </div>
      <Reveal className="mt-10">
        <div className="grid grid-cols-1 gap-4 rounded-[2rem] border border-[#071E33]/10 p-6 sm:p-8 md:grid-cols-12" data-testid="prosta-bonuses">
          <div className="md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#0A6FA0]">With 3 & 6 bottle packs</p>
            <p className="mt-2 font-display text-2xl font-bold text-[#071E33]">2 free bonuses</p>
          </div>
          {BONUSES.map(([t, d], i) => (
            <div key={t} className="flex gap-4 md:col-span-4" data-testid={`prosta-bonus-${i + 1}`}>
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#071E33] text-[#00AEEF]"><Gift className="h-5 w-5" /></span>
              <div>
                <p className="font-display text-lg font-semibold text-[#071E33]">{t}</p>
                <p className="text-sm text-[#071E33]/75">{d}</p>
              </div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
